import api from '../services/api'

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        species: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getSpecies(state) {
            return state.species;
        }
    },
  
    mutations: {
        setSpecies(state, data) {
            state.species = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.species = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        }
    },
  
    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        saveSpecies(context, options) {
            context.commit("saving");

            api.saveSpecies(
                options.species,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of Species (which will include the changes we requested)
                        context.commit("setSpecies", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadSpecies(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchSpecies({
                    success: function(response) {
                        context.commit("setSpecies", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        }
    }
}